import { useEditField } from '@atlassian/jira-issue-field-base';
import { TEXT_AREA_CF_TYPE } from '@atlassian/jira-platform-field-config';
import {
	assertClipboardDataIsCompatible,
	assertClipboardHasPlainTextFormat,
	useGenericClipboardHandler,
} from '../../../clipboard-handler/utils';
import type {
	ClipboardItem,
	ListIssueFieldTransformed,
	PasteHandler,
	PasteMetadata,
} from '../../../types';
import { createClipboardHelperComponent } from '../../utils';
import { richTextSupportedTypes } from '../supported-field-types';

const getPastedValue = (
	clipboardItem: ClipboardItem,
	metadata: PasteMetadata | null,
): string | null => {
	if (
		!assertClipboardHasPlainTextFormat(clipboardItem) ||
		!assertClipboardDataIsCompatible(metadata, richTextSupportedTypes)
	) {
		return null;
	}

	return JSON.parse(clipboardItem.plainText);
};

const useRichTextClipboardHandler: PasteHandler = (
	issue: { key: string },
	field: ListIssueFieldTransformed,
) => {
	const [, { saveValue }] = useEditField<string | null, null>({
		issueKey: issue.key,
		fieldKey: field.fieldId,
		fieldType: field.type,
		initialValue: null,
	});

	return useGenericClipboardHandler(field, getPastedValue, saveValue);
};

const RichTextClipboardHelper = createClipboardHelperComponent(useRichTextClipboardHandler);

export const richTextClipboardHandler = {
	[TEXT_AREA_CF_TYPE]: RichTextClipboardHelper,
};
